import css from './banner.module.scss';
import classNames from 'classnames';
import Description from 'src/components/description-block/description';
import Complaint from 'src/pages/complaint/complaint';
import { ReactComponent as LocationIcon } from 'src/assets/location.svg';
import { ComplaintEntityType } from 'src/constants/complaint-entity-type';
import { CardProps } from 'src/types';
import { ReactComponent as ExternalLinkIcon } from 'src/assets/external_link.svg';
import { useResize } from 'src/hooks/shared-hooks';
import { Link } from 'react-router-dom';

export default function Banner({ service, className, pages }: Readonly<CardProps>) {
  const dimensions = useResize();
  const mobileMode = dimensions.width < 500;

  const baseUrl = window.location.origin;
  const pathname = window.location.pathname;

  const isForeghtService = !service.url?.startsWith('/');

  const target = isForeghtService ? '_blank' : '_self';
  const modifiedUrl = service.url?.startsWith(baseUrl) ? service.url?.replace(baseUrl, '') : pathname + service.url;

  const url = isForeghtService ? service.url : modifiedUrl;

  const state = isForeghtService ? null : pages;

  const wrapper = (
    complaint: JSX.Element,
    onMouseEnter: React.MouseEventHandler<HTMLDivElement> | undefined,
    onMouseLeave: React.MouseEventHandler<HTMLDivElement> | undefined
  ) => (
    <div // NOSONAR
      className={classNames(css.banner, css[className])}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      {complaint}
      <div className={css.container}>
        <div className={css.image}>
          <img src={service.imgUrl} alt={service.title} />
        </div>
        <div className={css.content}>
          <div className={css.textGroup}>
            <Link to={url} state={state} target={target} rel='noopener, noreferrer' className={css.title}>
              <span>{service.title}</span>
              {service.url && <ExternalLinkIcon />}
            </Link>
            <Description description={service.description} />
            <div className={css.footer}>
              {service.phone && mobileMode && (
                <a href={`tel:${service.phone}`} target='_blank' rel='noopener, noreferrer'>
                  Зателефонувати
                </a>
              )}
              {service.locationName && (
                <span className={css.location}>
                  <LocationIcon />
                  <p>{service.locationName}</p>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Complaint
      key={service.id}
      entityId={service.id}
      entityType={ComplaintEntityType.SERVICE}
      targetTitle={service.title}
      alignRight
      wrapper={wrapper}
    />
  );
}
